import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axiosClient from 'api/axiosClient';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { updateBreadCrumbNews, updateSelecteDetail, updateMenuResearch } from 'redux/actions/menu';
import { SETTING_IMAGE_URL } from 'utils/constants';
import Loader from 'react-loader-spinner';
import { Calendar, Clock, MapPin } from 'react-feather';
import '../News/css/style.css';
import '../News/css/newsDetail.css';
import './EventDetail.css';

const EventDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const intl = useIntl();

    const pathSplit = window.location.pathname.split('/');
    const lang = pathSplit[1];
    const isVietnamese = lang === 'vi';

    const [event, setEvent] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthsVi = ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6",
                      "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"];

    useEffect(() => {
        window.scrollTo(0, 0);

        axiosClient.get(`/menuItem/1`).then((res) => {
            const menuResearch = res.data.find(item => item.title === 'Research');
            if (menuResearch) {
                dispatch(updateMenuResearch(menuResearch));
            }
        }).catch(err => console.error(err));

        setLoaded(false);
        axiosClient.get(`/events/${id}`)
            .then((res) => {
                const data = res.data;
                setEvent(data);

                dispatch(updateBreadCrumbNews([
                    { title: 'Research', path: '#' },
                    {
                        title: intl.formatMessage({ id: 'Conference & Workshop', defaultMessage: 'Conference & Workshop' }),
                        path: isVietnamese ? '/vi/conference-workshop' : '/conference-workshop'
                    },
                    { title: data.name || 'Detail', path: '' }
                ]));
                dispatch(updateSelecteDetail({ id: 1234 }));
                setLoaded(true);
            })
            .catch((err) => {
                console.error('Error fetching event detail:', err);
                setLoaded(true);
            });
    }, [id, dispatch, intl, isVietnamese]);


    if (!loaded) {
        return (
            <div className="ced-loader-wrapper">
                <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" />
            </div>
        );
    }

    if (!event) {
        return (
            <div className="ced-not-found">
                <p>{intl.formatMessage({ id: 'EventNotFound', defaultMessage: 'Event not found.' })}</p>
            </div>
        );
    }

    const imageUrl = event.image ? `${SETTING_IMAGE_URL}/${event.image}` : require('assets/img/custom/slide/1.jpg').default;

    const now = new Date().getTime();
    const targetDate = new Date(
        `${event.year}-${String(event.month).padStart(2, '0')}-${String(event.day).padStart(2, '0')}T${event.time_start}`
    ).getTime();
    const isPast = targetDate <= now;

    const dateStr = isVietnamese
        ? `${event.day} ${monthsVi[(event.month || 1) - 1]}, ${event.year}`
        : `${months[(event.month || 1) - 1]} ${event.day}, ${event.year}`;

    return (
        <div className="ced-container main-app">

            {/* Hero image */}
            <div className="ced-hero">
                <div className={`ced-status-badge ${isPast ? 'past' : 'upcoming'}`}>
                    {isPast
                        ? intl.formatMessage({ id: 'PastEvent', defaultMessage: 'Past Event' })
                        : intl.formatMessage({ id: 'Upcoming', defaultMessage: 'Upcoming' })}
                </div>
                <img src={imageUrl} alt={event.name} className="ced-hero-img" />
            </div>

            {/* Event info */}
            <div className="ced-content-wrapper">
                <h1 className="ced-title">{event.name}</h1>

                <div className="ced-meta">
                    <div className="ced-meta-item">
                        <Calendar size={16} className="ced-meta-icon" />
                        <span>{dateStr}</span>
                    </div>
                    {event.time_start && (
                        <div className="ced-meta-item">
                            <Clock size={16} className="ced-meta-icon" />
                            <span>{event.time_start}</span>
                        </div>
                    )}
                    {event.location && (
                        <div className="ced-meta-item">
                            <MapPin size={16} className="ced-meta-icon" />
                            <span>{event.location}</span>
                        </div>
                    )}

                </div>

                <hr className="ced-divider" />

                {/* Main content */}
                {event.content ? (
                    <div className="ced-body news_body">
                        {ReactHtmlParser(event.content)}
                    </div>
                ) : (
                    <p className="ced-no-content">
                        {intl.formatMessage({ id: 'NoContent', defaultMessage: 'No content available.' })}
                    </p>
                )}
            </div>
        </div>
    );
};

export default EventDetail;
